import { PersonalDetailsStep } from '../components';
import {
  register,
  setCurrentStep,
  setPersonalDetailsForm,
  clearRegistration,
} from 'screens/BrokerPortal/screens/Registration/store/actions';
import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';

export default connect(
  (state: RootState) => {
    return {
      form: state.registration.personalDetails.form,
      firmContext: state.registration.context.firm,
      selectedFirmId: state.registration.searchFirms.form.firmId,
      registerLoading: state.registration.personalDetails.registerLoading,
      searchFirmForm: state.registration.searchFirms.form,
      registerFirmForm: state.registration.registerFirm.form,
    };
  },
  { setPersonalDetailsForm, register, setCurrentStep, clearRegistration },
)(PersonalDetailsStep);
